import React from 'react';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';

const PolicyAcceptance = ({ accepted, onAcceptChange }) => {
  return (
    <div className="bg-secondary rounded-xl p-4 border border-border">
      <div className="flex items-start gap-3">
        <Checkbox
          id="policy"
          checked={accepted}
          onCheckedChange={onAcceptChange}
          className="mt-0.5 border-muted-foreground data-[state=checked]:bg-primary data-[state=checked]:border-primary"
        />
        <Label htmlFor="policy" className="text-sm text-foreground/80 leading-relaxed cursor-pointer">
          I accept the{' '}
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline font-medium"
            onClick={(e) => e.stopPropagation()}
          >
            Refund & Cancellation Policy
          </a>
          {' '}and{' '}
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline font-medium"
            onClick={(e) => e.stopPropagation()}
          >
            Terms of Service
          </a>
        </Label>
      </div>
    </div>
  );
};

export default PolicyAcceptance;
